import React from 'react';
import Icon from '../../Icon';
import { C } from '../../../utils/styles';

function fmt$(n) {
  return `$${Math.round(Number(n) || 0).toLocaleString()}`;
}

const LABELS = {
  majorMedical: { label: 'Major Medical', icon: 'medical-outline', unit: '/month' },
  dental: { label: 'Dental', icon: 'happy-outline', unit: '/month' },
  vision: { label: 'Vision', icon: 'eye-outline', unit: '/month' },
  retirement: { label: '401K', icon: 'wallet-outline', unit: '/month' },
};

export default function ExistingDeductionsCard({ existingDeductions, hide }) {
  if (hide || !existingDeductions) return null;
  const present = Object.entries(existingDeductions).filter(([, v]) => v?.present);
  if (present.length === 0) return null;

  return (
    <div data-testid="smart-upload-existing-deductions-panel" style={{
      background: '#fff', border: `1px solid ${C.border}`, borderRadius: 12, padding: 24, marginBottom: 16,
    }}>
      <div style={{ display: 'flex', alignItems: 'start', gap: 12, marginBottom: 16 }}>
        <Icon name="layers-outline" style={{ fontSize: 20, color: C.blue, marginTop: 2 }} />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>Existing Pre-Tax Deductions Detected</div>
          <div style={{ fontSize: 13, color: C.textMid, lineHeight: 1.5 }}>
            HealthCues stacks <strong>on top</strong> of these — adding incremental savings on remaining taxable income.
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
        {present.map(([key, v]) => {
          const meta = LABELS[key] || { label: key, icon: 'cube-outline', unit: '' };
          return (
            <div key={key} style={{
              background: C.bg, borderRadius: 10, padding: 14,
              display: 'flex', alignItems: 'center', gap: 12,
            }}>
              <div style={{
                width: 36, height: 36, borderRadius: 8, background: '#fff', color: C.blue,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <Icon name={meta.icon} style={{ fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontSize: 13, color: C.textMid }}>{meta.label}</div>
                <div style={{ fontSize: 16, fontWeight: 700 }}>
                  {v.count} employees · avg {fmt$(v.average)}{meta.unit}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
